import { Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { SKU_$reflection, Lang_$reflection } from "../Shopfoo.Domain.Types/Common.js";
import { Prices_$reflection } from "../Shopfoo.Domain.Types/Sales.js";
import { ApiError_$reflection } from "../Shopfoo.Shared/Errors.js";
import { union_type, option_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Product_$reflection } from "../Shopfoo.Domain.Types/Catalog.js";
import { Stock_$reflection } from "../Shopfoo.Domain.Types/Warehouse.js";
import { Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505, Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareQueryWithTranslations_1505 } from "../Remoting.js";

export class Toast extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Lang", "Prices", "Product", "Sale", "Stock", "Supply"];
    }
}

export function Toast_$reflection() {
    return union_type("Shopfoo.Client.Pages.Shared.Toast", [], Toast, () => [[["Item", Lang_$reflection()]], [["Item1", Prices_$reflection()], ["Item2", option_type(ApiError_$reflection())]], [["Item1", Product_$reflection()], ["Item2", option_type(ApiError_$reflection())]], [["Item1", SKU_$reflection()], ["Item2", option_type(ApiError_$reflection())]], [["Item1", Stock_$reflection()], ["Item2", option_type(ApiError_$reflection())]], [["Item1", SKU_$reflection()], ["Item2", option_type(ApiError_$reflection())]]]);
}

export function Env_fillTranslations(env, translations) {
    let copyOfStruct = env;
    copyOfStruct.FillTranslations(translations);
}

export function Env_prepareQueryWithTranslations(env, query) {
    let copyOfStruct;
    return Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareQueryWithTranslations_1505((copyOfStruct = env, copyOfStruct.FullContext), query);
}

export function Env_prepareRequest(env, request) {
    let copyOfStruct;
    return Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505((copyOfStruct = env, copyOfStruct.FullContext), request);
}

export function Env_user(env) {
    let copyOfStruct;
    return ((copyOfStruct = env, copyOfStruct.FullContext)).User;
}

export function Shopfoo_Client_Pages_Shared_Env_IFullContext__IFullContext_get_Translations(env) {
    return env.FullContext.Translations;
}

